<div class="row no-gutters">
    <div class="col">
        <input
            bsDatepicker
            [bsValue]="bsValue"
            (bsValueChange)="dateValueChange($event)"
            (blur)="callTouchedFormValidation()"
            [attr.disabled]="disabled ? '' : null"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [attr.placeholder]="
                disabled
                    ? ''
                    : required
                      ? ('requiredPlaceholder' | t: { format: placeholder })
                      : placeholder
            "
            class="form-control form-control-sm"
            (keydown)="dateKeyDown($event)"
        />
    </div>
    @if (showTimePicker && isInitialized) {
        <div class="col-auto" style="margin-top: -1px">
            <timepicker
                #timepicker
                [ngModel]="timeValue"
                (ngModelChange)="timeValueChange($event)"
                [showSpinners]="false"
                [showMeridian]="false"
                class="timepicker"
                [attr.disabled]="disabled ? '' : null"
                (keydown)="dateKeyDown($event)"
                [disabled]="disabled"
            ></timepicker>
        </div>
    }
</div>
